import { useState } from 'react';
import { ChevronDown, Check, X } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { SLA_STATUS_OPTIONS } from '@/constants/filter-options';

interface SlaStatusFilterProps {
  selected: string | null;
  onSelectionChange: (value: string | null) => void;
}

export function SlaStatusFilter({ selected, onSelectionChange }: SlaStatusFilterProps) {
  const [open, setOpen] = useState(false);
  const hasSelection = selected !== null;
  const selectedOption = SLA_STATUS_OPTIONS.find((o) => o.value === selected);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className={`flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full border transition-colors ${
            hasSelection
              ? 'border-brand-rose/40 bg-brand-rose/5 text-brand-rose'
              : 'border-slate-200 text-slate-600 bg-white hover:bg-slate-50'
          }`}
        >
          {hasSelection ? selectedOption?.label : 'SLA'}
          <ChevronDown className="w-3 h-3 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-2" align="start">
        <div className="space-y-1">
          {SLA_STATUS_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              onClick={() => {
                onSelectionChange(selected === opt.value ? null : opt.value);
                setOpen(false);
              }}
              className="flex items-center gap-2 w-full px-2 py-1.5 rounded-md hover:bg-slate-50 transition-colors text-left"
            >
              <Check
                className={`h-3.5 w-3.5 ${selected === opt.value ? 'opacity-100 text-brand-rose' : 'opacity-0'}`}
              />
              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${opt.bg} ${opt.color}`}>
                {opt.label}
              </span>
            </button>
          ))}
        </div>
        {hasSelection && (
          <button
            onClick={() => { onSelectionChange(null); setOpen(false); }}
            className="flex items-center gap-1 w-full mt-2 px-2 py-1.5 text-xs font-medium text-slate-500 hover:text-brand-rose rounded-md hover:bg-slate-50 transition-colors"
          >
            <X className="w-3 h-3" />
            Clear
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
}
